import { ref, onUnmounted } from 'vue'

export function useCamera() {
  const videoRef = ref(null)
  const streamActive = ref(false)
  const error = ref(null)
  let stream = null

  async function startCamera() {
    try {
      error.value = null
      const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)
      stream = await navigator.mediaDevices.getUserMedia({
        video: {
          facingMode: 'user',
          width: { ideal: isMobile ? 720 : 1280 },
          height: { ideal: isMobile ? 1280 : 720 }
        },
        audio: false
      })
      if (videoRef.value) {
        videoRef.value.srcObject = stream
        await videoRef.value.play()
        streamActive.value = true
      }
    } catch (err) {
      error.value = 'Camera access denied. Please check your camera permissions.'
      console.error('Camera error:', err)
    }
  }

  function stopCamera() {
    if (stream) {
      stream.getTracks().forEach(track => track.stop())
      stream = null
    }
    streamActive.value = false
  }

  onUnmounted(() => {
    stopCamera()
  })

  return {
    videoRef,
    streamActive,
    error,
    startCamera,
    stopCamera
  }
}
